import Draw2 from '../../../assets/Drawing/Draw (2).png';
import Draw3 from '../../../assets/Drawing/Draw (3).png';
import Draw4 from '../../../assets/Drawing/Draw (4).png';
import Draw5 from '../../../assets/Drawing/Draw (5).png';
import Draw6 from '../../../assets/Drawing/Draw (6).png';
import Draw7 from '../../../assets/Drawing/Draw (7).png';
import Draw8 from '../../../assets/Drawing/Draw (8).png';
import Draw9 from '../../../assets/Drawing/Draw (9).png';
import Draw10 from '../../../assets/Drawing/Draw (10).png';
import Draw11 from '../../../assets/Drawing/Draw (11).png';
import Draw12 from '../../../assets/Drawing/Draw (12).png';
import Draw13 from '../../../assets/Drawing/Draw (13).png';
import Draw14 from '../../../assets/Drawing/Draw (14).png';
import Draw15 from '../../../assets/Drawing/Draw (15).png';
import Draw16 from '../../../assets/Drawing/Draw (16).png';
import Draw17 from '../../../assets/Drawing/Draw (17).png';
import Draw18 from '../../../assets/Drawing/Draw (18).png';
import Draw19 from '../../../assets/Drawing/Draw (19).png';
import Draw20 from '../../../assets/Drawing/Draw (20).png';
import Draw21 from '../../../assets/Drawing/Draw (21).png';
import Draw22 from '../../../assets/Drawing/Draw (22).png';
import Draw23 from '../../../assets/Drawing/Draw (23).png';

export const paintings = [
  {
    id: 1,
    title: "Kehidupan Si Sore",
    image: Draw2,
    creationDate: "7 November 2024"
  },
  {
    id: 2,
    title: "Ladang Kedamaian",
    image: Draw3,
    creationDate: "7 November 2024"
  },
  {
    id: 3,
    title: "Warna Perjuangan",
    image: Draw4,
    creationDate: "7 Mei 2024"
  },
  {
    id: 4,
    title: "Wajah dalam Bayangan",
    image: Draw5,
    creationDate: "3 Juni 2024"
  },
  {
    id: 5,
    title: "Langit Biru",
    image: Draw6,
    creationDate: "6 Juni 2024"
  },
  {
    id: 6,
    title: "Biru angkasa",
    image: Draw7,
    creationDate: "11 Juli 2024"
  },
  {
    id: 7,
    title: "Senja di Ufuk Timur",
    image: Draw8,
    creationDate: "2 Agustus 2024"
  },
  {
    id: 8,
    title: "Tiang - Tiang Rindu",
    image: Draw9,
    creationDate: "3 Agustus 2024"
  },
  {
    id: 9,
    title: "La la land",
    image: Draw10,
    creationDate: "17 Agustus 2024"
  },
  {
    id: 10,
    title: "Dua malam bersama separuh hati",
    image: Draw11,
    creationDate: "12 Desember 2024"
  },
  {
    id: 11,
    title: "Makna hidup ada di saat ini",
    image: Draw12,
    creationDate: "7 Februari 2025"
  },
  {
    id: 12,
    title: "Good bye",
    image: Draw13,
    creationDate: "12 Februari 2025"
  },
  {
    id: 13,
    title: "Di ujung mimpi",
    image: Draw14,
    creationDate: "20 Februari 2025"
  },
  {
    id: 14,
    title: "Bayangan kelam dunia",
    image: Draw15,
    creationDate: "22 Februari 2025"
  },
  {
    id: 15,
    title: "Tentang kasih sayang",
    image: Draw16,
    creationDate: "1 Maret 2025"
  },
  {
    id: 16,
    title: "Hijau di kota abu-abu",
    image: Draw17,
    creationDate: "18 Maret 2025"
  },
  {
    id: 17,
    title: "Lampu membawa rindu",
    image: Draw18,
    creationDate: "29 Maret 2025"
  },
  {
    id: 18,
    title: "Keajaiban kecil",
    image: Draw19,
    creationDate: "10 April 2025"
  },
  {
    id: 19,
    title: "Prince Yellow and Princess Light",
    image: Draw20,
    creationDate: "22 April 2025"
  },
  {
    id: 20,
    title: "Bawa aku pergi",
    image: Draw21,
    creationDate: "5 Mei 2025"
  },
  {
    id: 21,
    title: "Langit ungu",
    image: Draw22,
    creationDate: "18 Juli 2025"
  },
  {
    id: 22,
    title: "Hening Malam",
    image: Draw23,
    creationDate: "30 Agustus 2025"
  },
];